// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Xkcem","label":"SetPasswdForm_label__y1tkW"};